export default __webpack_public_path__ + "static/media/noticks.8722a54e.svg";